import { render } from "./PhilipsInternshipProject.vue?vue&type=template&id=c724763e&scoped=true"
const script = {}

import "./PhilipsInternshipProject.vue?vue&type=style&index=0&id=c724763e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c724763e"]])

export default __exports__